import { Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{ fontSize?: number }>;

export const CardTransactionsSummaryLabel = ({
  fontSize = 14,
  children,
}: Props) => (
  <Typography
    fontSize={fontSize}
    fontWeight={600}
    letterSpacing={0.5}
    color={Colors.Text}
    textTransform="uppercase"
  >
    {children}
  </Typography>
);
